import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        model: _ctx.modelValue,
        "label-width": "auto",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["grid gap-4", [
                        _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-5' : (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead ? 'md:grid-cols-4' : 'md:grid-cols-3'),
                    ]])
          }, [
            _withDirectives(_createVNode(_component_el_form_item, {
              class: "no-margin",
              label: "組織"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OrganizationSelect, {
                  "model-value": _ctx.modelValue.organization_id,
                  "is-search": true,
                  placeholder: "組織を選択",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, organization_id: $event })))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
            ]),
            _withDirectives(_createVNode(_component_el_form_item, {
              class: "no-margin",
              label: "部門"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DepartmentSelect, {
                  "organization-id": _ctx.modelValue.organization_id,
                  "is-search": true,
                  "model-value": _ctx.modelValue.department_id,
                  placeholder: "部門を選択",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, department_id: $event }))),
                  onOrganizationIdChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('organizationIdChange', $event)))
                }, null, 8, ["organization-id", "model-value"])
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
            ]),
            _createVNode(_component_el_form_item, {
              class: "no-margin",
              label: "カテゴリ"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CategorySelect, {
                  "organization-id": _ctx.modelValue.organization_id,
                  "model-value": _ctx.modelValue.category_id,
                  "is-search": true,
                  placeholder: "カテゴリを選択",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, category_id: $event })))
                }, null, 8, ["organization-id", "model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "no-margin",
              label: "アイテム名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AutoCompleteInput, {
                  "model-value": _ctx.modelValue.material_name,
                  placeholder: "アイテム名を入力",
                  "storage-key": "material-name-history",
                  "max-history-items": 15,
                  ref: "materialNameInput",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, material_name: $event })))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                class: "w-24",
                type: "info",
                onClick: _ctx.handleSearch
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("検索")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_el_drawer, {
      class: "md:hidden bg-gray-200",
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.drawer) = $event)),
      title: "検索",
      direction: "ttb",
      "with-header": false,
      size: "auto"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            model: _ctx.modelValue,
            "label-width": "auto",
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createVNode(_component_el_form_item, {
                  class: "no-margin",
                  label: "組織"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_OrganizationSelect, {
                      "model-value": _ctx.modelValue.organization_id,
                      "is-search": true,
                      placeholder: "組織を選択",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, organization_id: $event })))
                    }, null, 8, ["model-value"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                ]),
                _withDirectives(_createVNode(_component_el_form_item, {
                  class: "no-margin",
                  label: "部門"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DepartmentSelect, {
                      "organization-id": _ctx.modelValue.organization_id,
                      "is-search": true,
                      "model-value": _ctx.modelValue.department_id,
                      placeholder: "部門を選択",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, department_id: $event }))),
                      onOrganizationIdChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('organizationIdChange', $event)))
                    }, null, 8, ["organization-id", "model-value"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                ]),
                _createVNode(_component_el_form_item, {
                  class: "no-margin",
                  label: "カテゴリ"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CategorySelect, {
                      "organization-id": _ctx.modelValue.organization_id,
                      "model-value": _ctx.modelValue.category_id,
                      "is-search": true,
                      placeholder: "カテゴリを選択",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, category_id: $event })))
                    }, null, 8, ["organization-id", "model-value"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    class: "no-margin flex-grow",
                    label: "アイテム名"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AutoCompleteInput, {
                        "model-value": _ctx.modelValue.material_name,
                        placeholder: "アイテム名を入力",
                        "storage-key": "material-name-history",
                        "max-history-items": 15,
                        ref: "materialNameInput",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:modelValue', { ..._ctx.modelValue, material_name: $event })))
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      class: "md:hidden ml-3",
                      type: "info",
                      onClick: _ctx.handleSearch,
                      circle: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_8, [
      _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"flex flex-grow items-center xl:justify-end\"><div class=\"md:hidden xl:block\"><div class=\"flex justify-end\"><span class=\"text-xs md:text-sm m-2 font-bold\">アラート区分</span><div class=\"flex flex-wrap gap-x-2\"><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#E63415] rounded-sm\"></div><span class=\"ml-1 text-xs md:text-sm\">1日以内</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#FF6600] rounded-sm\"></div><span class=\"ml-1 text-xs md:text-sm\">1日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#FFDE0A] rounded-sm\"></div><span class=\"ml-1 text-xs md:text-sm\">7日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#1EC79D] rounded-sm\"></div><span class=\"ml-1 text-xs md:text-sm\">15日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#14CCCC] rounded-sm\"></div><span class=\"ml-1 text-xs md:text-sm\">30日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#4167F0] rounded-sm\"></div><span class=\"ml-1 text-xs md:text-sm\">在庫数</span></div></div></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            class: "custom-icon-btn md:hidden",
            type: "info",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.drawer = true)),
            circle: ""
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "custom-icon-btn md:hidden",
            type: "info",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('add'))),
            circle: ""
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "hidden md:block w-24",
            type: "info",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('add')))
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("新規登録")
            ])),
            _: 1
          }),
          _createVNode(_component_el_upload, {
            class: "",
            ref: "upload",
            "on-change": _ctx.handleImport,
            "auto-upload": false,
            "show-file-list": false,
            accept: ".csv"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: "CSVインポート",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "custom-icon-btn mx-3",
                    type: "info",
                    circle: ""
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createElementVNode("span", { class: "material-symbols-outlined" }, " upload_2 ", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["on-change"]),
          _createVNode(_component_el_button, {
            class: "custom-icon-btn",
            type: "info",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('export'))),
            circle: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: "CSVエクスポート",
                placement: "top"
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"flex justify-end hidden md:block xl:hidden\"><span class=\"text-sm mr-2 font-bold\">アラート区分</span><div class=\"flex flex-wrap gap-x-2\"><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#E63415] rounded-sm\"></div><span class=\"ml-1 text-sm\">1日以内</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#FF6600] rounded-sm\"></div><span class=\"ml-1 text-sm\">1日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#FFDE0A] rounded-sm\"></div><span class=\"ml-1 text-sm\">7日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#1EC79D] rounded-sm\"></div><span class=\"ml-1 text-sm\">15日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#14CCCC] rounded-sm\"></div><span class=\"ml-1 text-sm\">30日前</span></div><div class=\"flex items-center\"><div class=\"h-3 w-3 bg-[#4167F0] rounded-sm\"></div><span class=\"ml-1 text-sm\">在庫数</span></div></div></div>", 1))
      ])
    ])
  ]))
}